import { render, staticRenderFns } from "./CellUpload.vue?vue&type=template&id=ff2e8e84&scoped=true"
import script from "./CellUpload.vue?vue&type=script&lang=js"
export * from "./CellUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2e8e84",
  null
  
)

export default component.exports